import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "_styleguide";
import { hasCategory, saveForm } from "_helpers/form";
import { saveApplication } from "_helpers/application";
import axios from "axios";
import "./Actions.scss";

function Actions(props) {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);

  const getBlackbook = async (n) => {
    const carInfo = props.form?.car;
    const data = {
      car: carInfo,
      id: localStorage.getItem("sky_form_id") || null,
    };
    let blackbookValue = {};
    try {
      const saveResults = await axios.post(
        `${process.env.REACT_APP_API_PATH}/blackbook`,
        data
      );
      blackbookValue = saveResults?.data;
    } catch (err) {
      console.log(err);
    }
    return blackbookValue;
  };

  const handleNext = async (which) => {
    console.log(which, props);
    const category = props.name;
    if (hasCategory(category)) {
      setIsSaving(true);
      try {
        const formData = { ...props.form };
        if (category === "car") {
          const blackbookData = await getBlackbook();
          formData.car.tradein = blackbookData.tradein || 0;
          formData.car.hotsale = blackbookData.hotsale || 0;
          formData.quote.up_to_amount = blackbookData.quote || 0;
        }
        const saveData = await saveForm({ ...props.form }, category);
        if (props.application) {
          await saveApplication(props.application, saveData);
        }
      } catch (err) {
        console.log(err);
      }
      setIsSaving(false);
    }
    navigate(props[which]);
  };

  return (
    <div className="sky-actions">
      {props.previous && !props.customPrevious ? (
        <Button
          loading={isSaving}
          onClick={() => handleNext("previous")}
          type="secondary"
          size="large"
          block
        >
          Back
        </Button>
      ) : null}
      {props.customPrevious ? props.customPrevious : null}
      {props.next && !props.customNext ? (
        <Button
          disabled={props.nextDisabled}
          loading={isSaving}
          onClick={() => handleNext("next")}
          type="primary"
          size="large"
          block
        >
          Next
        </Button>
      ) : null}
      {props.customNext ? props.customNext : null}
    </div>
  );
}

export default Actions;
